<h1 mat-dialog-title>Note</h1>
<div mat-dialog-content>
  <div class="note-form">
    <mat-form-field class="full-width-ta">
      <!--<mat-label>Leave a comment</mat-label>-->
      <textarea matInput cdkTextareaAutosize placeholder="Message"
                [disabled]="isReadOnly"
                [(ngModel)]="message"></textarea>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="dialog-btn-end">
  <button mat-button color="primary" (click)="onClose(false)">Close</button>
  <button *ngIf="!isReadOnly" mat-button color="primary" (click)="onClose(true)">Save</button>
</div>
